export default __webpack_public_path__ + "static/media/select-arrow-down.7f92d076.svg";